import type { Variation } from '@gonfalon/openapi/types';

export function findVariationIndexById(id: string, variations: Variation[]) {
  return variations.findIndex((v) => v._id === id);
}
